import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
const ConsultationComponent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const componentRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (componentRef.current) {
      observer.observe(componentRef.current);
    }

    return () => {
      if (componentRef.current) {
        observer.unobserve(componentRef.current);
      }
    };
  }, []);

  const containerStyle = {
    position: 'relative',
    overflow: 'hidden',
    minHeight: '350px',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const videoStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  };

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(65, 6, 132, 0.3)', // Purple overlay with shade #410684
  };
  

  const contentContainerStyle = {
    position: 'relative',
    zIndex: 1,
    maxWidth: '800px',
    margin: '0 auto',
    padding: '40px 20px',
    textAlign: 'center',
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(50px)',
    transition: 'opacity 1s ease-out, transform 1s ease-out',
  };

  const subtitleStyle = {
    fontSize: 'clamp(14px, 4vw, 16px)', // Responsive font size
    marginBottom: '15px',
    color: '#ffffff',
    fontWeight: '400',
    lineHeight: '1.5', // Using relative line-height
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
    transition: 'opacity 1s ease-out 0.2s, transform 1s ease-out 0.2s',
};
  const headingStyle = {
    fontSize: '32px',
    fontWeight: '600',
    marginBottom: '20px',
    color: '#ffffff',
    fontFamily:'Oswald, sans serif',
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
    transition: 'opacity 1s ease-out 0.3s, transform 1s ease-out 0.3s',
  };

  const buttonStyle = {
    backgroundColor: '#410684',
    color: 'white',
    padding: '10px 20px',
    borderRadius: '4px',
    fontFamily: 'Oswald, sans-serif',
    border: 'none',
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: '500',
    cursor: 'pointer',
    textDecoration: 'none',
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
    transition: 'opacity 1s ease-out 0.4s, transform 1s ease-out 0.4s, background-color 0.3s',
  };
  const handleConsultationClick = () => {
    navigate('/contactus');
  };
  return (
    <div ref={componentRef} style={containerStyle}>
      <video 
        autoPlay 
        loop 
        muted 
        playsInline
        style={videoStyle}
      >
        <source src="/consultation.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      
      <div style={overlayStyle} />
      
      <div style={contentContainerStyle}>
        <p style={subtitleStyle}>
          Drop us a line! We are here to answer your questions 24/7
        </p>

        <h2 style={headingStyle}>
          NEED A CONSULTATION?
        </h2>

        <button 
         onClick={handleConsultationClick}
          style={buttonStyle}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = '#5a1ba8';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = '#410684';
          }}
        >
          CONTACT US
        </button>
      </div>

      <style jsx>{`
        @media (max-width: 768px) {
          h2 {
            font-size: 28px !important;
          }
          p {
            font-size: 14px !important;
          }
          button {
            padding: 10px 20px !important;
            font-size: 16px !important;
          }
        }
        @media (max-width: 480px) {
          h2 {
            font-size: 24px !important;
          }
          p {
            font-size: 12px !important;
          }
          button {
            padding: 8px 16px !important;
            font-size: 14px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default ConsultationComponent;